export default __webpack_public_path__ + "static/12 - Helyreállítás előtte-utána-a501de6329edb7b475bfdd92441ee6ed.jpg";